<template>
  <div class="tabs-bar">
    <div class="tabs-scroll" ref="scroll" @wheel.prevent="onWheel">
      <div
        v-for="(t, i) in tabs"
        :key="t.routeName"
        class="tab-item"
        :class="{ active: t.routeName === activeName, home: t.closable === false }"
        :draggable="t.closable !== false"
        @click="go(t)"
        @contextmenu.prevent="openMenu(t, $event)"
        @dragstart="onDragStart(i, $event)"
        @dragover.prevent
        @drop="onDrop(i)"
      >
        <span class="dot"></span>
        <span class="tab-title">{{ t.title }}</span>
        <a-icon
          v-if="t.closable !== false"
          type="close"
          class="tab-close"
          @click.stop="close(t)"
        />
      </div>
    </div>

    <!-- 右键菜单 -->
    <ul
      v-if="menu.visible"
      class="tab-ctx"
      :style="{ left: menu.x + 'px', top: menu.y + 'px' }"
    >
      <li @click="ctxRefresh"><a-icon type="reload" /> 刷新当前</li>
      <li :class="{ disabled: onlyHomeOrSelf }" @click="ctxCloseOthers"><a-icon type="close" /> 关闭其他</li>
      <li :class="{ disabled: noClosable }" @click="ctxCloseAll"><a-icon type="close-circle" /> 关闭全部</li>
    </ul>
  </div>
</template>

<script>
import { tabsStore } from '@/store/tabsView'

export default {
  name: 'TabsBar',
  data() {
    return {
      dragIdx: -1,
      menu: { visible: false, x: 0, y: 0, tab: null },
    }
  },
  computed: {
    tabs() {
      return tabsStore.tabs
    },
    activeName() {
      return this.$route.name
    },
    onlyHomeOrSelf() {
      // 除首页和右键的这个页签外, 没有别的可关 -> "关闭其他"无意义
      const t = this.menu.tab
      if (!t) return true
      return this.tabs.filter((x) => x.closable !== false && x.routeName !== t.routeName).length === 0
    },
    noClosable() {
      return this.tabs.every((t) => t.closable === false)
    },
  },
  mounted() {
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu)
  },
  watch: {
    activeName() {
      this.$nextTick(this.scrollActiveIntoView)
    },
  },
  methods: {
    go(t) {
      if (t.routeName !== this.$route.name) this.$router.push(t.path).catch(() => {})
    },
    close(t) {
      const next = tabsStore.closeTab(t.routeName, this.$route.name)
      if (next) this.$router.push(next.path).catch(() => {})
    },
    onWheel(e) {
      if (this.$refs.scroll) this.$refs.scroll.scrollLeft += e.deltaY
    },
    scrollActiveIntoView() {
      const box = this.$refs.scroll
      if (!box) return
      const el = box.querySelector('.tab-item.active')
      if (el && el.scrollIntoView) el.scrollIntoView({ inline: 'nearest', block: 'nearest' })
    },
    onDragStart(i, e) {
      this.dragIdx = i
      if (e.dataTransfer) e.dataTransfer.effectAllowed = 'move'
    },
    onDrop(i) {
      if (this.dragIdx >= 0) tabsStore.moveTab(this.dragIdx, i)
      this.dragIdx = -1
    },
    openMenu(t, e) {
      this.menu = { visible: true, x: e.clientX, y: e.clientY, tab: t }
    },
    closeMenu() {
      if (this.menu.visible) this.menu.visible = false
    },
    ctxRefresh() {
      const t = this.menu.tab
      this.closeMenu()
      if (!t) return
      const doRefresh = () => tabsStore.refresh(this, t.routeName)
      if (t.routeName === this.$route.name) doRefresh()
      else this.$router.push(t.path).then(doRefresh).catch(() => {})
    },
    ctxCloseOthers() {
      const t = this.menu.tab
      this.closeMenu()
      if (!t || this.onlyHomeOrSelf) return
      tabsStore.closeOthers(t.routeName)
      if (t.routeName !== this.$route.name) this.$router.push(t.path).catch(() => {})
    },
    ctxCloseAll() {
      this.closeMenu()
      if (this.noClosable) return
      const home = tabsStore.closeAll()
      if (home && home.routeName !== this.$route.name) this.$router.push(home.path).catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.tabs-bar {
  height: 40px;
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  padding: 0 8px;
  position: relative;
}
.tabs-scroll {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: thin;
  &::-webkit-scrollbar { height: 4px; }
  &::-webkit-scrollbar-thumb { background: #d9d9d9; border-radius: 2px; }
}
.tab-item {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  background: #fafafa;
  color: #555;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  &:hover { color: #E9A13B; border-color: #E9A13B; }
  .dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #c8c8c8;
    margin-right: 6px;
  }
  .tab-close {
    margin-left: 6px;
    font-size: 11px;
    color: #999;
    border-radius: 50%;
    &:hover { background: #E9A13B; color: #fff; }
  }
  &.active {
    background: #E9A13B;
    border-color: #E9A13B;
    color: #fff;
    .dot { background: #fff; }
    .tab-close { color: #fff; &:hover { background: rgba(255,255,255,0.3); } }
  }
}
.tab-ctx {
  position: fixed;
  z-index: 2000;
  min-width: 120px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  margin: 0;
  list-style: none;
  li {
    padding: 6px 14px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    .anticon { margin-right: 6px; color: #888; }
    &:hover { background: #fff7e6; color: #E9A13B; .anticon { color: #E9A13B; } }
    &.disabled { color: #ccc; cursor: not-allowed; pointer-events: none; .anticon { color: #ccc; } }
  }
}
</style>
